const Products = [
    {
        id: 1,
        pName: 'OFFICIAL FANLIGHT',
        price: '35,000',
        imgUrl: 'product_image/1.JPG',
        detailImgUrl1: 'product_image/1-1.JPG',
        detailImgUrl2: 'product_image/1-2.JPG',
        detailImgUrl3: 'product_image/1-3.JPG',
        des:
            '[상품정보]\n  - 상품 : SUZY OFFICIAL FANLIGHT\n - 소재 : ABS, PC, 실리콘, 알루미늄\n - 구성품 : 응원봉, 스트랩, 사용자설명서\n - 사이즈 : 75.4 X 74.8 X 247(mm)\n - 무게 : 205.7(g)\n - 판매원 : SM BRAND MARKETING\n - POWER : 알카라인 AAA 건전지 3개(건전지 미포함 상품)\n - 작동시간 : 약 3시간(조작 방법에 따라 상이할 수 있습니다.)\n - KC 인증 : R-C-REI-SME-SM01\n - 제조사 : 드림어스 컴퍼니 ',
        property: 'Concert',
    },
    {
        id: 2,
        pName: 'ARTIST CASE - Purpose',
        price: '25,000',
        imgUrl: 'product_image/2.JPG',
        detailImgUrl1: 'product_image/2-1.JPG',
        detailImgUrl2: 'product_image/2-2.JPG',
        detailImgUrl3: 'product_image/2-3.JPG',
        des:
            '[상품정보]\n - 상품 : 케이스\n - 소재 : POLYCARBONATE\n - 사이즈(CM) : 14x6.5x0.8\n - 판매원 : SM BRAND MARKETING\n - 제조국 : 한국\n - 제조년월 : 2019.03 ',
        property: 'Living',
    },
    {
        id: 3,
        pName: 'CHEER UP BRACELET',
        price: '25,000',
        imgUrl: 'product_image/3.JPG',
        detailImgUrl1: 'product_image/3-1.JPG',
        detailImgUrl2: 'product_image/3-2.JPG',
        detailImgUrl3: 'product_image/3-3.JPG',
        des:
            '[상품정보]\n - 상품 : 팔찌\n - 소재 : METAL\n - 사이즈(CM) : 6x2x0.5\n - 판매원 : SM BRAND MARKETING\n - 제조국 : 한국\n - 제조년월 : 2019.12 ',
        property: 'Accessory',
    },
    {
        id: 4,
        pName: 'Pinky Festival',
        price: '10,900',
        imgUrl: 'product_image/4.JPG',
        detailImgUrl1: 'product_image/4-1.JPG',
        detailImgUrl2: 'product_image/4-2.JPG',
        detailImgUrl3: 'product_image/4-3.JPG',
        des:
            '[상품정보]\n - 상품명 :띠부띠부_핑키페스티벌\n - 사이즈(cm) : 22X10X0.65\n - 무게(g) : 12g\n - 판매원 : SM BRAND MARKETING\n - 제조국 : 대한민국\n - 판매개시일 : 2019. 08 ',
        property: 'Beauty',
    },
    {
        id: 5,
        pName: 'LOVELOVE KEYRING',
        price: '25,000',
        imgUrl: 'product_image/5.JPG',
        detailImgUrl1: 'product_image/5-1.JPG',
        detailImgUrl2: 'product_image/5-2.JPG',
        detailImgUrl3: 'product_image/5-3.JPG',
        des:
            '[상품정보]\n - 상품 : 키링\n - 소재 : METAL\n - 사이즈(CM) : 6.5x14.5x1.3\n - 판매원 : SM BRAND MARKETING\n - 제조국 : 한국\n - 제조년월 : 2019.05 ',
        property: 'Accessory',
    },
    {
        id: 6,
        pName: 'ZERO MINI BAG & KEYRING SET BLACK',
        price: '19,900',
        imgUrl: 'product_image/6.PNG',
        detailImgUrl1: 'product_image/6-1.JPG',
        detailImgUrl2: 'product_image/6-2.JPG',
        detailImgUrl3: 'product_image/6-3.JPG',
        des:
            '[상품정보]\n - 상품 : ZERO MINI BAG & KEYRING SET\n - 색상 : BLACK\n - 사이즈(cm) : 가로 31.5 * 세로 18 * 넓이 10.5 / 끈길이 42, 키링 7.5*6.4\n - 제조국 : 중국  ',
        property: 'Living',
    },
    {
        id: 7,
        pName: 'CHEER UP STICK KEYRING',
        price: '9,500',
        imgUrl: 'product_image/7.PNG',
        detailImgUrl1: 'product_image/7-1.JPG',
        detailImgUrl2: 'product_image/7-2.JPG',
        detailImgUrl3: 'product_image/7-3.JPG',
        des:
            '[상품정보]\n - 상품명 :수지(Suzy) 응원봉 키링\n - 규격 : 47.7*100.7*29.8\n - 무게(g) : 56g\n - 판매원 : SM BRAND MARKETING\n - 제조국 : 중국\n - 판매개시일 : 2019. 10 ',
        property: 'Accessory',
    },
    {
        id: 8,
        pName: 'SUZY SOLO ALBUM',
        price: '16,500',
        imgUrl: 'product_image/8.jpg',
        detailImgUrl1: 'product_image/8-1.jpg',
        detailImgUrl2: 'product_image/8-2.jpg',
        detailImgUrl3: 'product_image/8-3.jpg',
        des:
            '음반소개\n 앨범 사양\n 1. 앨범 1종\n - 화보집 96P\n -가사지8P\n 2. [랜덤] 커버 엽서\n - 4EA / 랜덤 1종 표지 노출\n 3. [랜덤] 포토카드\n - RANDOM 1 OUTOF 8\n 4. CD-R\n - CD-R1종 ',
        property: 'Music',
    },
    {
        id: 9,
        pName: 'LOVELOVE NECKLACE',
        price: '29,000',
        imgUrl: 'product_image/9.PNG',
        detailImgUrl1: 'product_image/9-1.PNG',
        detailImgUrl2: 'product_image/9-2.PNG',
        detailImgUrl3: 'product_image/9-3.PNG',
        des:
            '[상품정보]\n *설레는 크리스마스의 반짝이는 떨림을 담은 목걸이(한정판)*\n - 상품 : 트윙클 실버 목걸이\n - 소재 : 925 SILVER + RHODIUM Plating (3mils) - 스톤 : C.Z White 약 3mm\n - 사이즈(CM) : 9.5x7x3, pandant 1.1x1.3, chain 45+3\n - 판매원 : SM BRAND MARKETING \n - 제조국 : 한국\n - 제조년월 : 2019.12 ',
        property: 'Accessory',
    },
    {
        id: 10,
        pName: 'ARTIST MTM',
        price: '68,000',
        imgUrl: 'product_image/10.PNG',
        detailImgUrl1: 'product_image/10-1.PNG',
        detailImgUrl2: 'product_image/10-2.PNG',
        detailImgUrl3: 'product_image/10-3.PNG',
        des:
            ' [상품정보]\n - 상품 : 맨투맨\n - 소재 : COTTON\n - 사이즈(CM) : 어깨 52.5\n 가슴 65\n 밑단 52\n 소매기장 63\n 총길이 70.5\n - 판매원 : SM BRAND MARKETING\n - 제조국 : 한국\n - 제조년월 : 2019.10',
        property: 'Living',
    },
    {
        id: 11,
        pName: 'TYPOGRAPHIC TRAVEL POUCH with ALIFE',
        price: '27,000',
        imgUrl: 'product_image/11.PNG',
        detailImgUrl1: 'product_image/11-1.PNG',
        detailImgUrl2: 'product_image/11-2.PNG',
        detailImgUrl3: 'product_image/11-3.PNG',
        des:
            ' 상품 : 트래블 파우치 \n 소재 : COATED COTTON \n 사이즈(CM) : 25X14X2 \n 무게(g) : 95 \n 판매원 : SM BRAND MARKETING\n 제조국 : 한국\n 제조년월 : 2019.06',
        property: 'Living',
    },
    {
        id: 12,
        pName: 'SLEEPING MASK',
        price: '18,000',
        imgUrl: 'product_image/12.JPG',
        detailImgUrl1: 'product_image/12-1.JPG',
        detailImgUrl2: 'product_image/12-2.JPG',
        detailImgUrl3: 'product_image/12-3.JPG',
        des:
            '[사용방법]\n 1. 세안 후 화장수로 피부결을 정돈합니다. \n 2. 마스크를 꺼내어 눈을 중심으로 얼굴에 밀착합니다. \n 3. 10~20분 정도 휴식 후 마스크를 떼어냅니다.\n 4. 얼굴에 남은 내용물은 두드려 흡수시킵니다.',
        property: 'Beauty',
    },
    {
        id: 13,
        pName: 'Miss A Colors',
        price: '14,900',
        imgUrl: 'product_image/13.jpg',
        detailImgUrl1: 'product_image/13-1.jpg',
        detailImgUrl2: 'product_image/13-2.jpg',
        detailImgUrl3: 'product_image/13-3.jpg',
        des:
            ' miss A가 세 번째 미니앨범이자 일곱 번째 프로젝트 앨범 [Colors]로 돌아온다.\n 1년 5개월 만에 돌아온 그녀들 miss A! 지난 앨범 [허쉬]로 어쿠스틱한 분위기와 인상적인 곡으로 속삭이는 듯한 가사와 몽환적인 멜로디로 사랑을 받았던 miss A이기에 이번 컴백 앨범에 대한 기대감을 더욱 고조시키고 있다. \n 세 번째 미니 앨범의 타이틀곡 다른 남자 말고 너 는 대중적인 힙합과 트랙 리듬이 인상적인 곡으로 여자들의 적극적인 사랑방식을 대변해주는 곡이다.',
        property: 'Music',
    },
    {
        id: 14,
        pName: 'Miss A 미니앨범 4집',
        price: '14,900',
        imgUrl: 'product_image/14.jpg',
        detailImgUrl1: 'product_image/14-1.jpg',
        detailImgUrl2: 'product_image/14-2.gif',
        detailImgUrl3: 'product_image/14-3.jpg',
        des:
            "지금 가장 뜨거운 아티스트, 미쓰에이 수지와 엑소 백현이 듀엣곡 'Dream(드림)'을 발표한다.\n SM과 JYP의 콜라보로 뜨거운 화제를 모은 두 사람은 ‘Dream’에서 달콤한 하모니를 선보인다.\n 바쁜 연기 활동 중에도 노래뿐만 아니라 최근 직접 작사를 하며 가수 행보를 놓치지 않는 수지, 엑소의 메인 보컬로서 뛰어난 가창력을 인정받으며 글로벌로 뻗어 나가는 백현.\n ‘Dream’은 두 사람이 가진 뮤지션적인 색깔을 보여줄 수 있는 곡이자 뮤지션으로서 한 뼘 더 성장하는 계기가 될 것이다. ",
        property: 'Music',
    },
    {
        id: 15,
        pName: '2018 WALL CALENDAR (벽걸이 캘린더) Limited Edition',
        price: '22,000',
        imgUrl: 'product_image/15.jpg',
        detailImgUrl1: 'product_image/15-1.jpg',
        detailImgUrl2: 'product_image/15-2.jpg',
        detailImgUrl3: 'product_image/15-3.jpg',
        des:
            '수지만의 로맨틱한 감성과 러블리한 매력이 녹아든 이번 2018 시즌그리팅 제2탄!\n 다양한 착장을 소화하면서 완성한 여러 스타일리시한 화보컷이 포스터를 방불케하는\n 500*770mm 크기에 큼직하게 담겼다. ',
        property: 'Photo',
    },
    {
        id: 16,
        pName: 'Suzy?Suzy 화보집',
        price: '15,000',
        imgUrl: 'product_image/16.jpg',
        detailImgUrl1: 'product_image/16-1.jpg',
        detailImgUrl2: 'product_image/16-2.jpg',
        detailImgUrl3: 'product_image/16-3.jpg',
        des:
            'miss A 수지 첫 개인 화보집 suzy?suzy.\n -가장 수지답게, 수지다운, 수지만의 화보집\n -‘하루라도 젊을 때’의 진짜 수지를 만나다.\n miss A 수지의 첫 단독 화보집 ‘suzy? suzy.’는 ‘하루라도 젊을 때’라는 유쾌한 발상에서 시작되었다.\n 이처럼 ‘suzy? suzy.’는 20대의 진짜 수지를 담고 있다. 솔직하고 거짓 없는 가장 ‘수지다운’ 모습을 기록하기 위해 본인이 기획단계서부터 의상, 표지 선정까지 적극적으로 참여했다.',
        property: 'Photo',
    },
    {
        id: 17,
        pName: 'LOVELOVE MULTI BRACELET',
        price: '32,000',
        imgUrl: 'product_image/17.PNG',
        detailImgUrl1: 'product_image/17-1.PNG',
        detailImgUrl2: 'product_image/17-2.PNG',
        detailImgUrl3: 'product_image/17-3.PNG',
        des:
            '[상품정보]\n - 상품 : 팔찌\n - 소재 : METAL,STONE\n - 사이즈(CM) : 9x9x4\n - 판매원 : SM BRAND MARKETING\n - 제조국 : 한국\n - 제조년월 : 2019.05 ',
        property: 'Accessory',
    },
    {
        id: 18,
        pName: 'HOLOGRAM POSTCARD',
        price: '2,000',
        imgUrl: 'product_image/18.PNG',
        detailImgUrl1: 'product_image/18-1.PNG',
        detailImgUrl2: 'product_image/18-2.PNG',
        detailImgUrl3: 'product_image/18-3.PNG',
        des:
            '[상품정보]\n 상품 : 홀로그램 엽서 (1EA)\n 소재 : PAPER, FILM\n 사이즈 : 11X15.4 (CM)\n 판매원 : SM ENTERTAINMENT\n 제조국 : 한국\n 제조 연월 : 2020.02\n 중량 : 12g ',
        property: 'Accessory',
    },
    {
        id: 19,
        pName: 'TOWEL',
        price: '11,900',
        imgUrl: 'product_image/19.PNG',
        detailImgUrl1: 'product_image/19-1.PNG',
        detailImgUrl2: 'product_image/19-2.PNG',
        detailImgUrl3: 'product_image/19-3.PNG',
        des:
            '- 상품 : 타올\n - 소재 : COTTON\n - 사이즈(CM) : 30x40x2\n - 판매원 : SM BRAND MARKETING\n - 제조국 : 한국\n - 제조년월 : 2020.03',
        property: 'Living',
    },
    {
        id: 20,
        pName: 'SUZY 2nd ALBUM',
        price: '11,900',
        imgUrl: 'product_image/20.jpg',
        detailImgUrl1: 'product_image/20-1.jpg',
        detailImgUrl2: 'product_image/20-2.jpg',
        detailImgUrl3: 'product_image/20.-3jpg',
        des:
            '음반소개\n 앨범 사양\n 1. 앨범 1종\n - 화보집 96P\n -가사지8P\n 2. [랜덤] 커버 엽서\n - 4EA / 랜덤 1종 표지 노출\n 3. [랜덤] 포토카드\n - RANDOM 1 OUTOF 8\n 4. CD-R\n - CD-R1종 ',
        property: 'Music',
    },
    {
        id: 21,
        pName: 'Bad But Good ALBUM',
        price: '19,900',
        imgUrl: 'product_image/21.png',
        detailImgUrl1: 'product_image/21-1.jpg',
        detailImgUrl2: 'product_image/21-2.jpg',
        detailImgUrl3: 'product_image/21.-3jpg',
        des:
            '음반소개\n 앨범 사양\n 1. 앨범 1종\n - 화보집 96P\n -가사지8P\n 2. [랜덤] 커버 엽서\n - 4EA / 랜덤 1종 표지 노출\n 3. [랜덤] 포토카드\n - RANDOM 1 OUTOF 8\n 4. CD-R\n - CD-R1종 ',
        property: 'Music',
    },
    {
        id: 22,
        pName: '2017 게스 화보집',
        price: '15,900',
        imgUrl: 'product_image/22.jpg',
        detailImgUrl1: 'product_image/22-1.jpg',
        detailImgUrl2: 'product_image/22-2.jpg',
        detailImgUrl3: 'product_image/22.-3jpg',
        des:
            ' 하이웨이스트, 플레어 붓컷, 오버롤 팬츠 등 레트로 무드를 가장 드라마틱하게 연출해줄 데님 라인을 비롯해 오리지널스 로고가 적용된 맨투맨, 컬러 블록 아노락 점퍼 등 비비드한 컬러감의 상의류들까지 더해져 레트로 트렌드의 집합체라 해도 손색없을 정도로 완벽한 라인업을 선보인다.',
        property: 'Photo',
    },
    {
        id: 23,
        pName: '마리끌레르 화보집',
        price: '15,900',
        imgUrl: 'product_image/23.jpg',
        detailImgUrl1: 'product_image/23-1.jpg',
        detailImgUrl2: 'product_image/23-2.jpg',
        detailImgUrl3: 'product_image/23.-3jpg',
        des:
            ' 수지가 순정만화를 찢고 나온 듯한 여신 미모로 또 한번 독보적인 존재감을 드러냈다.\n 글로벌 코스메틱 브랜드 랑콤의 뮤즈인 수지는 마리끌레르 3월호의 뷰티 화보를 장식하며 시크함과 우아함, 청순함까지 팔색조의 매력을 뽐냈다.\n 공개된 화보에서 수지는 도도한 매력과 함께 차분하고 부드러운 핑크 무드로 우아하고 사랑스러운 매력을 뿜어낸다. 짙은 네이비 컬러의 의상에 차분한 톤다운 핑크컬러의 입술로 카메라를 그윽하게 응시하는 눈빛만으로 시크한 무드를 자아낸다.',
        property: 'Photo',
    },
    {
        id: 24,
        pName: 'OFFICIAL FANLIGHT VER.2.0',
        price: '36,000 ',
        imgUrl: 'product_image/24.PNG',
        detailImgUrl1: 'product_image/24-1.PNG',
        detailImgUrl2: 'product_image/24-2.PNG',
        detailImgUrl3: 'product_image/24-3.PNG',
        des:
            ' [상품정보]\n - 상품 : SUZY OFFICIAL FANLIGHT VER.2.0\n - 소재 : ABS, PC, 실리콘, 알루미늄\n - 구성품 : 응원봉, 스트랩, 사용자설명서\n - 사이즈 : 111.1 X 94 X 257.7 (mm)\n - 무게 : 185.5 (g)\n - 판매원 : SM BRAND MARKETING\n - POWER : 알칼라인 AAA 건전지 3개\n - 제조년월 : 2019.10\n - KC 인증 : R-CMM-REI-SME-SJLS01',
        property: 'Concert',
    },
    {
        id: 25,
        pName: 'Beyond LIVE T-SHIRT',
        price: '35,000',
        imgUrl: 'product_image/25.PNG',
        detailImgUrl1: 'product_image/25-1.PNG',
        detailImgUrl2: 'product_image/25-2.PNG',
        detailImgUrl3: 'product_image/25-3.PNG',
        des:
            '[상품정보]\n 상품 : 티셔츠 (1EA)\n 소재 : COTTON\n  사이즈 : 가슴둘레 112, 밑단둘레 112, 어깨너비 47, 소매기장 25, 총장 72.5 (CM)\n  판매원 : SM ENTERTAINMENT\n 제조국 : 한국\n 제조 연월 : 2020.09\n 중량 : 350g ',
        property: 'Concert',
    },
    {
        id: 26,
        pName: 'Protectiong natural shine tone up sun cushion',
        price: '46,000',
        imgUrl: 'product_image/26.PNG',
        detailImgUrl1: 'product_image/26-1.PNG',
        detailImgUrl2: 'product_image/26-2.PNG',
        detailImgUrl3: 'product_image/26-3.PNG',
        des:
            '- 사용기한: 제조일로부터 2년/ 개봉 후 6개월 내 사용\n - 제품 사용 방법: 메이크업 전 후에 자외선 차단과 부 톤업이 필요한 경우 퍼프에 적당량 발라 두드려 펴 발라줍니다.\n Tip 1. 선쿠션 사용 휴 레몬쿠션을 사용하시면 보다 좋은 커버력을 느끼실 수 있습니다. ',
        property: 'Beauty',
    },
    {
        id: 27,
        pName: 'SUZY A SET',
        price: '49,900',
        imgUrl: 'product_image/27.PNG',
        detailImgUrl1: 'product_image/27-1.PNG',
        detailImgUrl2: 'product_image/27-2.PNG',
        detailImgUrl3: 'product_image/27-3.PNG',
        des:
            '- 사용기한: 제조일로부터 2년/ 개봉 후 6개월 내 사용\n - 제품 사용 방법: 메이크업 전 후에 자외선 차단과 부 톤업이 필요한 경우 퍼프에 적당량 발라 두드려 펴 발라줍니다.\n Tip 1. 선쿠션 사용 휴 레몬쿠션을 사용하시면 보다 좋은 커버력을 느끼실 수 있습니다. ',
        property: 'Beauty',
    },
    {
        id: 28,
        pName: 'SUZY B SET',
        price: '49,900',
        imgUrl: 'product_image/27.PNG',
        detailImgUrl1: 'product_image/27-1.PNG',
        detailImgUrl2: 'product_image/27-2.PNG',
        detailImgUrl3: 'product_image/27-3.PNG',
        des:
            '[상품정보]\n [안내사항]\n * 본 상품의 구성은 랜덤으로 구매 후 단순 변심에 의한 교환 및 환불이 불가합니다.\n [추가 안내사항]\n * 본 제품은 사용연령 만 14세 이상 분들을 위한 제품으로 어린이용이 아니며, 용도 이외의 사용은 금합니다.\n * 본 제품은 공정거래위원회 고시 소비자 분쟁해결 기준에 의거 교환 또는 보상 받을 수 있습니다.',
        property: 'Beauty',
    },
];

export default Products;
